import type {FC} from 'react';

import type {Props} from './types';

import {Clickable} from '../../../../uikit/Clickable';
import {TestID} from '../../../../utils/test-utils/data-test-id';
import * as S from './styles';

export const AccountsListItemJSX: FC<Props> = ({
  isPrimary,
  onDeleteIconClick,
  type,
  value,
}) => (
  <S.Container testID={TestID.accounts.list_item.container}>
    <S.ContentContainer>
      <S.Icon type={type} />
      <S.Content>
        <S.Value testID={TestID.accounts.list_item.value}>{value}</S.Value>
      </S.Content>
    </S.ContentContainer>
    {isPrimary ? <S.PrimaryIcon /> : null}
    {onDeleteIconClick ? (
      <Clickable
        onClick={onDeleteIconClick}
        testID={TestID.accounts.button.delete}
      >
        <S.DeleteIcon />
      </Clickable>
    ) : null}
  </S.Container>
);
